import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectMyProjects,
  selectProjectDetails,
  selectIsLoading,
} from "../redux/selector";
import { selectSelectedTeam } from "app/redux/selector";
import { IAvatar } from "app/containers/Features/containers/TeamSettings/container/MySetting/types";

export const useProjectsProgress = () => {
  const myProjects = useSelector(selectMyProjects);
  const projectDetails = useSelector(selectProjectDetails);
  const isLoading = useSelector(selectIsLoading);
  const selectedTeam = useSelector(selectSelectedTeam);

  const combinedProjects = useMemo(() => {
    return myProjects.map((proj) => {
      const details = projectDetails.find((d) => d._id === proj._id);

      const workspaceProject = (selectedTeam as any)?.projects?.find(
        (p) => p._id === proj._id,
      );

      const name = details?.name || workspaceProject?.projectName || "Untitled Project";

      const teamName =
        details?.team?.name ||
        (selectedTeam as any)?.name ||
        (selectedTeam as any)?.teamName ||
        "";

      const memberCount = proj.teamMemberCount ?? proj.teamMembers ?? 0;

      const avatar = (details?.avatar || workspaceProject?.avatar) as
        | IAvatar
        | undefined;

      const developerProgress = proj.developerProgress;
      const qaProgress = proj.qaProgress;

      return {
        ...proj,
        name,
        teamName,
        memberCount,
        description: teamName
          ? `${teamName} • ${memberCount} members`
          : `${memberCount} members`,
        avatar,
        iconLetter: name ? name.charAt(0).toUpperCase() : "",
        iconColor: avatar?.color || "#3B82F6",
        developerProgress,
        qaProgress,
      };
    });
  }, [myProjects, projectDetails, selectedTeam]);

  return {
    combinedProjects,
    isLoading,
  };
};
